<div
  class="select-container"
  [style.width]="width"
  [class.readonly]="readonly"
>
  <div class="header">
    @if (label) {
      <div class="label">{{ label }}</div>
    }

    @if (link && text) {
      <div>
        <app-link [link]="link" [text]="text"/>
      </div>
    }
  </div>

  @if (isDisabled) {
    <div class="dropdown">
      <button
        type="button"
        class="input-wrapper input"
        [class]="{'opened': dropdownOpen}"
        [disabled]="isDisabled"
      >
        @if (value) {
          <ng-container
            [ngTemplateOutlet]="shareTemplate"
            [ngTemplateOutletContext]="{ securityType: value }"
          />
        } @else {
          <div class="select-placeholder">{{ placeholder }}</div>
        }
        <i class="icon ic-select-20"></i>
      </button>
    </div>
  } @else {
    <div ngbDropdown class="dropdown" (openChange)="getDropdownState($event)">
      <button
        ngbDropdownToggle
        type="button"
        class="input-wrapper input"
        [disabled]="isDisabled"
        [class]="{'opened': dropdownOpen}"
      >
        @if (value) {
          <ng-container
            [ngTemplateOutlet]="shareTemplate"
            [ngTemplateOutletContext]="{ securityType: value }"
          />
        } @else {
          <div class="select-placeholder">{{ placeholder }}</div>
        }
        <i class="icon ic-select-20"></i>
      </button>
      <div ngbDropdownMenu class="dropdown-menu">
        @if (options.length) {
          @for (securityType of options; track securityType.trackId) {
            <button
              ngbDropdownItem
              type="button"
              class="dropdown-item"
              [class.selected]="securityType === value"
              (click)="selectOption(securityType)"
            >
              <div class="dropdown-button">
                <ng-container
                  [ngTemplateOutlet]="shareTemplate"
                  [ngTemplateOutletContext]="{ securityType }"
                />
                <i class="icon ic-checkmark-circle-16"></i>
              </div>
            </button>
          }
        } @else {
          <div class="no-options">{{ noOptionsText }}</div>
        }

        <div [hidden]="!allowAddNewShareType">
          <app-divider margin="8px 0"/>

          <button
            ngbDropdownItem
            type="button"
            class="dropdown-item"
            [disabled]="isDisabled"
            (click)="openCreateShareTypeModal()"
          >
            <div class="dropdown-button add-share-type-button">
              <i class="icon ic-add-20"></i>
              <span>Add Share Type</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  }

  @if (helperText) {
    <div class="helper">{{ helperText }}</div>
  }

  @if (displayValidationError) {
    <app-validation-error/>
  }
</div>

<ng-template #shareTemplate let-securityType="securityType">
  <app-share-class-type-label [securityType]="securityType"/>
</ng-template>
